<route>
{
  "name": "memberAdd",
  "meta": {
    "order": 3,
    "isVisible": false,
    "iconName": "mdi-pen"
  }
}
</route>
<template>
  <div>
    <page-title
      :title="$t('pages.members.title')">
      <v-btn
        outlined
        @click="$router.go(-1)"
        color="secondary">
        {{$t('general.back')}}
      </v-btn>
    </page-title>
    <v-form
      v-model="formIsValid"
      class="form-horizontal"
    >
      <form-item
        v-model="formData.name"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textbox"
        icon="mdi-form-textbox"
        :label="$t('models.name')"
        :placeholder="$t('models.name')"
      ></form-item>
      <form-item
        v-model="formData.phone"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textbox"
        icon="mdi-form-textbox"
        :label="$t('models.phone')"
        :placeholder="$t('models.phone')"
      ></form-item>
      <form-item
        v-model="formData.isadmin"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="checkbox"
        icon="mdi-form-textbox"
        :label="$t('models.isadmin')"
        :placeholder="$t('models.isadmin')"
      ></form-item>
      <form-action>
        <v-btn
          :disabled="!formIsValid"
          color="success"
          depressed
          @click="onSubmitForm"
        >
          {{ $t('pages.forms.submitButtonText') }}
        </v-btn>
        <v-btn
          color="secondary"
          depressed
          outlined
          @click="$router.go(-1)"
        >
          {{ $t('pages.forms.cancelButtonText') }}
        </v-btn>
      </form-action>
    </v-form>
  </div>
</template>

<script>
export default {
  layout: APP_CONFIG.layout.mainPanelLayout,
  data: () => ({
    // NOTE: Keep this name same in all form pages and components
    formIsValid: true,
    // NOTE: Keep this name same in all form pages and components
    formData: {
      name: '',
      phone: '',
      password: ''
    }
  }),
  computed: {
    nameRules () {
      return [
        v => !!v || this.$t('pages.forms.nameTextRuleRequired'),
        v => (v && v.length <= 10) || this.$t('pages.forms.nameTextRuleMaxLength')
      ]
    },
    shebaRules () {
      return [
        v => (v && v.length === 24) || this.$t('pages.forms.shebaRuleLength'),
        v => (v && /^\d+$/.test(v)) || this.$t('pages.forms.shebaRuleOnlyNumber')
      ]
    },
    fileRules () {
      return [
        v => (v && v.length > 0) || 'Required'
      ]
    },
    complexItems () {
      return [...Array(5)].map((_, index) => ({
        id: index + 1,
        firstName: this.faker.name.firstName(),
        lastName: this.faker.name.lastName(),
        amount: this.faker.finance.amount()
      }))
    },
    radioOptions () {
      return [
        {
          text: this.$t('pages.forms.genderRadioOptionMale'),
          value: 'm'
        },
        {
          text: this.$t('pages.forms.genderRadioOptionFemale'),
          value: 'f'
        }
      ]
    }
  },
  methods: {
    add () {
      this.$store.dispatch('member/add', {
        id: this.$route.params.id,
        name: this.formData.name,
        isadmin: this.formData.isadmin,
        phone: this.formData.phone,
        password: this.formData.password
      }).then((response) => {
        this.$router.push({name: 'members'})
      })
    },
    // NOTE: Keep this name same in all form pages and components
    onSubmitForm () {
      this.add()
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
